import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import { useTPAComponentsContext } from 'wix-ui-tpa/cssVars';

export const useSplitQuestions = (
  filteredQuestions: QuestionEntry[],
): {
  leftQuestions: QuestionEntry[];
  rightQuestions: QuestionEntry[];
  indexesLeftQuestions: number[];
  indexesRightQuestions: number[];
} => {
  const { seo = false } = useTPAComponentsContext();
  let leftQuestions: QuestionEntry[],
    rightQuestions: QuestionEntry[],
    indexesLeftQuestions: number[],
    indexesRightQuestions: number[];
  if (seo) {
    const middleIndex = Math.ceil(filteredQuestions.length / 2);
    leftQuestions = filteredQuestions.slice(0, middleIndex);
    rightQuestions = filteredQuestions.slice(middleIndex);

    indexesLeftQuestions = new Array(leftQuestions.length)
      .fill(0)
      .map((_, index) => index + 1);
    indexesRightQuestions = new Array(rightQuestions.length)
      .fill(0)
      .map((_, index) => index + leftQuestions.length + 1);
  } else {
    leftQuestions = filteredQuestions.filter((item, index) => index % 2 === 0);
    rightQuestions = filteredQuestions.filter((item, index) => index % 2 === 1);

    indexesLeftQuestions = leftQuestions.map((item, index) => index * 2 + 1);
    indexesRightQuestions = rightQuestions.map((item, index) => index * 2 + 2);
  }
  return {
    leftQuestions,
    rightQuestions,
    indexesLeftQuestions,
    indexesRightQuestions,
  };
};
